import http from './fetch'
import {
  NEWS_APP_CODE,
  NEWS_LEGACY_TYPE_MAP,
  normalizeNewsCategory,
  normalizeNewsItem,
  normalizeNewsListItem,
} from '@/utils/news'

function getNewsApiBase() {
  const host = window.location.hostname || ''
  if (
    host === 'localhost' ||
    host === '127.0.0.1' ||
    host.startsWith('192.168.')
  ) {
    return '/cms-api/api/open'
  }
  return 'https://cms.km-union.com/api/open'
}

function unwrapItems(res) {
  if (Array.isArray(res?.items)) {
    return res.items
  }
  if (Array.isArray(res?.data?.items)) {
    return res.data.items
  }
  if (Array.isArray(res?.data)) {
    return res.data
  }
  return []
}

function unwrapTotal(res) {
  return (
    res?.total ??
    res?.totalCount ??
    res?.data?.total ??
    res?.data?.totalCount ??
    0
  )
}

function resolveCategoryId(params = {}) {
  if (params.category_id || params.categoryId) {
    return params.category_id || params.categoryId
  }

  return NEWS_LEGACY_TYPE_MAP[String(params.type)] || params.type || ''
}

export function apiListNewsCategories(params = {}) {
  const query = {
    app_code: params.app_code || NEWS_APP_CODE,
  }

  return http(`${getNewsApiBase()}/categories`, query, 'get', true, false).then(
    (res) => {
      return {
        errcode: 0,
        data: {
          data: unwrapItems(res).map(normalizeNewsCategory),
        },
      }
    }
  )
}

// 兼容旧接口名，内部切换到新的开放新闻接口
export function apiListInfoByPage(params = {}) {
  const pageNo = params.pageNo || params.page || 1
  const pageSize = params.pageSize || params.page_size || 10
  const categoryId = resolveCategoryId(params)
  const query = {
    app_code: params.app_code || NEWS_APP_CODE,
    page: pageNo,
    page_size: pageSize,
  }

  if (categoryId !== '') {
    query.category_id = categoryId
  }
  if (params.keyword) {
    query.keyword = params.keyword
  }

  return http(`${getNewsApiBase()}/contents`, query, 'get', true, false).then(
    (res) => {
      const items = unwrapItems(res).map((item) =>
        normalizeNewsListItem({
          ...item,
          category_id: item.category_id || categoryId,
          pageNo,
          pageSize,
          type: params.type || categoryId,
        })
      )

      return {
        errcode: 0,
        data: {
          data: items,
          totalCount: unwrapTotal(res),
          pageNo,
          pageSize,
        },
      }
    }
  )
}

export function apiGetNewsContentDetail(id) {
  return http(
    `${getNewsApiBase()}/contents/${id}`,
    {},
    'get',
    true,
    false
  ).then((res) => {
    return {
      errcode: 0,
      data: normalizeNewsItem(res),
    }
  })
}
